import { Column,CreateDateColumn,Entity,JoinColumn,ManyToOne,OneToMany,PrimaryGeneratedColumn,UpdateDateColumn,VersionColumn,} from 'typeorm';
import { RmCountPriceListLogsEntity } from './rm-count-pricelist-logs.entity';
import { CompanyCategoryEnum } from '@gtpl/shared-models/raw-material-procurement';
import { HarvestTypes, TypeOfCutEnum } from '@gtpl/shared-models/common-models';

@Entity('rm_rates')
export class    RmRates {
  @PrimaryGeneratedColumn('increment', { name: 'rm_rates_id' })
  rmratesId: number;


  @Column('decimal', {
    precision: 10, 
    scale: 2,      
    nullable: false,
    name: 'count',
})
count: number;

    @Column('decimal', {
        precision: 10, 
    scale: 2, 
        nullable: false,
        // length: 30,
        name: 'price',
    })
    price: number;

    @Column('varchar', {
        nullable: false,
        name: 'company',
    })
    company: string;

    @Column("enum",{
        nullable:true,
        name:"category",
        enum: CompanyCategoryEnum,
        // default:CompanyCategoryEnum.OWN
    })
    category:CompanyCategoryEnum;

    @Column("enum",{
        nullable:true,
        name:"type",
        enum: HarvestTypes,
    })
    type:HarvestTypes;

    @Column('int',{
        nullable: false,
        // length: 30,
        name: 'count_range_id',
    })
    rmcountPriceListID:number

    @Column('boolean', {
        nullable: false,
        name: 'isActive',
        default: true,
    })
    isActive: boolean | null;

    @Column('varchar', {
        nullable: false,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;
    
    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;
    
        @UpdateDateColumn({
            name: "updated_at",
            type:'datetime'
        })
        updatedAt: Date;

        
    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag',
    })
    versionFlag: number;

    // @Column('int', {
    //     nullable: false,
    //     name: 'product_id',
    // })
    // productId: number;

    @Column({
        name: 'effective_from_date',
        type: 'datetime',
        nullable: true,
    })
    effectiveFromDate: Date;

    @Column({
        name: 'effective_to_date',
        type: 'datetime',
        nullable: true,
    })
    effectiveToDate: Date;
    
    //  @OneToMany(type => RmCountPriceListLogsEntity, info => info.rmcountPriceListId, { cascade: true })
    //  rmpricelist: RmCountPriceListLogsEntity[];
    }

   

    
